import { IBaseLineDx } from "./BaseLineDx";

export interface IEventDx {
  id?: string;
  recurrenceId?: string;
  name: string;
  description: string;
  amount?: number;
  createdDate: Date;
  eventType: string;
  baseline?: IBaseLineDx;
  projectId: number;
  author: string;
  related?: string;
  tag?: string;
  notificationsPolicy?: string;
  tamUser?: string;
}

export default class EventDx {
  private id?: string;
  private recurrenceId?: string;
  private name: string;
  private description: string;
  private amount?: number;
  private createdDate: Date;
  private eventType: string;
  private baseline?: IBaseLineDx;
  private projectId: number;
  private author: string;
  private related?: string;
  private tag?: string;
  private notificationsPolicy?: string;
  private tamUser?: string;

  constructor(dto: IEventDx) {
    Object.assign(this, dto);
  }

  get getId(): string {
    return this.id;
  }

  set setId(value: string) {
    this.id = value;
  }

  get getRecurrenceId(): string {
    return this.recurrenceId;
  }

  set setRecurrenceId(value: string) {
    this.recurrenceId = value;
  }

  get getName(): string {
    return this.name;
  }

  set setName(value: string) {
    this.name = value;
  }

  get getDescription(): string {
    return this.description;
  }

  set setDescription(value: string) {
    this.description = value;
  }

  get getAmount(): number {
    return this.amount;
  }

  set setAmount(value: number) {
    this.amount = value;
  }

  get getCreatedDate(): Date {
    return this.createdDate;
  }

  set setCreatedDate(value: Date) {
    this.createdDate = value;
  }

  get getEventType(): string {
    return this.eventType;
  }

  set setEventType(value: string) {
    this.eventType = value;
  }

  get getBaseline(): IBaseLineDx {
    return this.baseline;
  }

  set setBaseline(value: IBaseLineDx) {
    this.baseline = value;
  }

  get getProjectId(): number {
    return this.projectId;
  }

  set setProjectId(value: number) {
    this.projectId = value;
  }

  get getAuthor(): string {
    return this.author;
  }

  set setAuthor(value: string) {
    this.author = value;
  }

  get getRelated(): string {
    return this.related;
  }

  set setRelated(value: string) {
    this.related = value;
  }

  get getTag(): string {
    return this.tag;
  }

  set setTag(value: string) {
    this.tag = value;
  }

  get getNotificationsPolicy(): string {
    return this.notificationsPolicy;
  }

  set setNotificationsPolicy(value: string) {
    this.notificationsPolicy = value;
  }

  get getTamUser(): string {
    return this.tamUser;
  }

  set setTamUser(value: string) {
    this.tamUser = value;
  }
}
